import { combineReducers } from 'redux';
import UnitHome from './UnitHome';
import PostpaidBooking from './PostpaidBooking';

export default combineReducers({
  PostpaidBooking,
  UnitHome,
});
